import { ChangeDetectionStrategy, Component, inject } from '@angular/core';

import { TranslatePipe } from '@ngx-translate/core';

import { IconComponent } from '../../icons/icon.component';
import { IconName } from '../../icons/registry';
import { NotificationService, Toast, ToastVariant } from '../../service/notification.service';

interface ToastVisuals {
  container: string;
  iconWrap: string;
  iconColor: string;
  iconName: IconName;
}

const TOAST_VISUALS: Record<ToastVariant, ToastVisuals> = {
  success: {
    container: 'border-success/30',
    iconWrap: 'bg-success/10',
    iconColor: 'text-success',
    iconName: 'check-circle',
  },
  info: {
    container: 'border-info/30',
    iconWrap: 'bg-info/10',
    iconColor: 'text-info',
    iconName: 'info-circle',
  },
  warning: {
    container: 'border-warning/30',
    iconWrap: 'bg-warning/10',
    iconColor: 'text-base-content',
    iconName: 'alert-triangle',
  },
  error: {
    container: 'border-error/30',
    iconWrap: 'bg-error/10',
    iconColor: 'text-error',
    iconName: 'alert-triangle',
  },
};

@Component({
    selector: 'app-toast-host',
    imports: [TranslatePipe, IconComponent],
    templateUrl: './toast-host.component.html',
    styleUrl: './toast-host.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ToastHostComponent {
  protected readonly notifications = inject(NotificationService);

  protected dismiss(id: string): void {
    this.notifications.dismiss(id);
  }

  protected visualsFor(toast: Toast): ToastVisuals {
    return TOAST_VISUALS[toast.variant];
  }
}
